import { auth } from "./en/auth";
import { common } from "./en/common";
import { contracts } from "./en/contracts";
import { customers } from "./en/customers";
import { dashboard } from "./en/dashboard";
import { deals } from "./en/deals";
import { documents } from "./en/documents";
import { nav } from "./en/nav";
import { organizations } from "./en/organizations";
import { products } from "./en/products";
import { quotations } from "./en/quotations";
import { orders } from "./en/orders";
import { deliveryNotes } from "./en/deliveryNotes";
import { reports } from "./en/reports";
import { shared } from "./en/shared";
import { systemAdmin } from "./en/systemAdmin";
import { templates } from "./en/templates";
import { profile } from "./en/profile";
import { debug } from "./en/debug";
import { status } from "./en/status";
import { settings } from "./en/settings";
import { warehouse } from "./en/warehouse";
import { inventory } from "./en/inventory";
import { sales } from "./en/sales";
import { worksheets } from "./en/worksheets";
import { tasks } from "./en/tasks";
import projects from "./en/projects";
import { notifications } from "./en/notifications";
import { formBuilder, myForms, formRenderer, formFiller, formSubmissions } from "./en/formBuilder";
import { listBuilder } from "./en/formBuilder";
import { notes } from "./en/notes";
import { customerPortal } from "./en/customerPortal";
import { customerSignup } from "./en/customerSignup";
import { customerAccess } from "./en/customerAccess";
import { leads } from "./en/leads";
import { timeTracking } from "./en/timeTracking";
import projectReports from './en/projectReports';
import onboarding from './en/onboarding';
import mfa from './en/mfa';
import { saas } from './en/saas';
import { documentStorage } from './en/documentStorage';

export default {
  auth,
  common,
  nav,
  dashboard,
  customers,
  products,
  quotations,
  orders,
  deliveryNotes,
  deals,
  reports,
  organizations,
  systemAdmin,
  profile,
  status,
  contracts,
  shared,
  debug,
  templates,
  documents,
  settings,
  warehouse,
  inventory,
  sales,
  worksheets,
  tasks,
  projects,
  notifications,
  formBuilder,
  listBuilder,
  myForms,
  formRenderer,
  formFiller,
  formSubmissions,
  notes,
  customerPortal,
  customerSignup,
  customerAccess,
  leads,
  timeTracking,
  projectReports,
  onboarding,
  mfa,
  saas,
  documentStorage
};
